import { useContext, useMemo } from 'react'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { SourceWallet, SourceWalletTypes } from 'types/move/move'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

export const useSourceWallet = (): SourceWallet => {
  const [walletAction] = useContext(WalletActionContext)

  const sourceWallet: SourceWallet = useMemo(() => {
    const { sourceCustomerWallet, sourceWallet, sourceWalletType } = walletAction?.meta || {}

    if (sourceWalletType === WalletTransferType.MAIN && !!sourceWallet) {
      return {
        walletId: sourceWallet?.lsid,
        walletName: sourceWallet?.description,
        currency: sourceWallet?.currency?.code,
        balance: sourceWallet?.balance,
        walletType: SourceWalletTypes.MAIN,
      }
    } else if (sourceWalletType === WalletTransferType.CUSTOMER && !!sourceCustomerWallet) {
      return {
        walletId: sourceCustomerWallet.id,
        walletName: sourceCustomerWallet?.name,
        currency: sourceCustomerWallet?.balance?.currencyCode,
        balance: sourceCustomerWallet?.balance?.value,
        walletType: SourceWalletTypes.CUSTOMER,
      }
    }
  }, [walletAction])

  return sourceWallet
}
